import { CordMessage } from "frontend/canvas-designer-new/cord/cord-thread/cord-message";
import { useBoardValue } from "frontend/state/board-state";
import { Tooltip } from "frontend/ui-components/floaters/tooltip";
import { useHover } from "frontend/ui-components/floaters/use-hover";
import { memo, useCallback, useMemo, useRef } from "react";
import consts from "shared/consts";
import { CordThread as CordThreadType, CordUserMap } from "shared/datamodel/cord";
import { format } from "timeago.js";
import style from "./cord-thread.module.css";

export const CordThread = memo(({ thread, users }: { thread: CordThreadType; users: CordUserMap }) => {
  const author = useMemo(() => users.get(thread.firstMessage.authorID), [users, thread.firstMessage.authorID]);
  const [{ stageRef }] = useBoardValue();

  const nameRef = useRef<HTMLDivElement>(null);
  const nameHover = useHover(nameRef);

  const onThreadClick = useCallback(() => {
    stageRef?.focusElement?.(`${consts.CANVAS_ELEMENTS.COMMENT}-${thread.id}`);
  }, [stageRef, thread.id]);

  return (
    <div className={style.container} onClick={onThreadClick}>
      <div className={style.header}>
        <div className={style.author}>
          <img className={style.authorAvatarImage} src={author?.profilePictureURL} alt={author?.displayName} />
          <div className={style.authorNameContainer}>
            <div className={style.authorName} ref={nameRef}>
              {author?.displayName}
            </div>
            {nameHover && (
              <Tooltip
                design="monday"
                label={author?.displayName}
                relativeTo={nameRef}
                side={"bottom"}
                customStyle={{ borderRadius: 3 }}
              />
            )}
            <div className={style.authorTime}>{format(thread.firstMessage.createdTimestamp)}</div>
          </div>
        </div>
      </div>
      <CordMessage message={thread.firstMessage.content} />
      {thread.total >= 1 && (
        <div className={style.amountOfReplies}>
          {thread.total - 1} {`${thread.total - 1 > 1 ? "replies" : "reply"}`}
        </div>
      )}
    </div>
  );
});

CordThread.displayName = "CordThread";
